import React from 'react'
import styles from './MainContent.module.scss'

interface MainContentProps {
  children: React.ReactNode
  className?: never
}

export const MainContent: React.FC<MainContentProps> = ({ children }) => (
  <div className={styles.mainContent}>{children}</div>
)
